
import { faCertificate, faMobile, faPlug, faTools, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from '../../components/widget/Card';
import classes from './Admin.module.css';

function AdminPage(props) {

    return <>
        <div className="container mt-4 pb-5">
            <div className="row g-4">

                <div className="col-md-6 pb-4">
                    <Card className={classes.cardBg}>
                        <a href="/admin/perfil">
                            <img src="img/admin/admin-profile.png" alt="Editar Perfil" className={classes.imgCard} />
                        </a>

                        <div className="card-content">
                            <h4 className="card-title">Perfil</h4>
                            <p>
                                Gerência de dados pessoais, senha e preferências da conta.
                            </p>
                        </div>

                        <div className="card-read-more">
                            <a
                                href="/admin/perfil"
                                className="btn btn-primary w-100"
                            >
                                <FontAwesomeIcon icon={faUser} /> PERFIL
                            </a>
                        </div>
                    </Card>
                </div>

                <div className="col-md-6 pb-4">
                    <Card>
                        <a className="img-card" href="/admin/usuarios">
                            <img src="img/admin/admin-accounts.png" alt="Gerenciar usuários" className={classes.imgCard} />
                        </a>

                        <div className="card-content">
                            <h4 className="card-title">Usuários</h4>
                            <p>
                                Gerência de usuários e permissões de acesso ao sistema.
                            </p>
                        </div>

                        <div className="card-read-more">
                            <a
                                href="/admin/usuarios"
                                className="btn btn-primary w-100"
                            >
                                <FontAwesomeIcon icon={faUsers} /> USUÁRIOS
                            </a>
                        </div>
                    </Card>
                </div>                

                <div className="col-md-6">
                    <Card>
                        <a className="img-card" href="/admin/aplicativos">
                            <img src="img/admin/admin-apps.png" alt="Editar configurações" className={classes.imgCard} />
                        </a>

                        <div className="card-content">
                            <h4 className="card-title">Aplicativos</h4>
                            <p>
                                Gerência de aplicativos
                            </p>
                        </div>

                        <div className="card-read-more">
                            <a
                                href="/admin/aplicativos"
                                className="btn btn-primary w-100"
                            >
                                <FontAwesomeIcon icon={faMobile} /> APLICATIVOS
                            </a>
                        </div>
                    </Card>
                </div>

                <div className="col-md-6 pb-4">
                    <Card>
                        <a className="img-card" href="/admin/licencas">
                            <img src="img/admin/admin-licenses.png" alt="Gerenciar Licenças" className={classes.imgCard} />
                        </a>

                        <div className="card-content">
                            <h4 className="card-title">Licenças</h4>
                            <p>
                                Gerência de licenças de aplicativos, ativações e validade.
                            </p>
                        </div>

                        <div className="card-read-more">
                            <a
                                href="/admin/licencas"
                                className="btn btn-primary w-100"
                            >
                                <FontAwesomeIcon icon={faCertificate} /> LICENÇAS
                            </a>
                        </div>
                    </Card>
                </div>


                <div className="col-md-6">
                    <Card>
                        <a className="img-card" href="/admin/sistemasexternos">
                            <img src="img/admin/admin-externalsystems.png" alt="Sistemas Externos" className={classes.imgCard} />
                        </a>

                        <div className="card-content">
                            <h4 className="card-title">Sistemas Externos</h4>
                            <p>
                                Sistemas de terceiros utilizados por nossa equipe.
                            </p>
                        </div>

                        <div className="card-read-more">
                            <a
                                href="/admin/sistemasexternos"
                                className="btn btn-primary w-100"
                            >
                                <FontAwesomeIcon icon={faPlug} /> SISTEMAS EXTERNOS
                            </a>
                        </div>
                    </Card>
                </div>


                <div className="col-md-6">
                    <Card>
                        <a className="img-card" href="/admin/configuracoes">
                            <img src="img/admin/admin-settings.png" alt="Editar configurações" className={classes.imgCard} />
                        </a>

                        <div className="card-content">
                            <h4 className="card-title">Configurações</h4>
                            <p>
                                Ajuste parâmetros globais e integrações do sistema.
                            </p>
                        </div>

                        <div className="card-read-more">
                            <a
                                href="/admin/configuracoes"
                                className="btn btn-primary w-100"
                            >
                                <FontAwesomeIcon icon={faTools} /> CONFIGURAÇÕES
                            </a>
                        </div>
                    </Card>
                </div>



            </div>
        </div>
    </>
}

export default AdminPage;